import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import 'typeface-roboto';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import './index.css';

import { Auth0Provider } from '@auth0/auth0-react';
import { UseCollectionProvider } from 'utils/useCollection';
import App from './App';
import * as serviceWorker from './serviceWorker';

const theme = createTheme();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeProvider theme={theme}>
    <Auth0Provider
      domain="exo-qa-us.us.auth0.com"
      clientId="sJt0MMjB7WjwITI8XfCESCL0J2tVsNbn"
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      <Router>
        <UseCollectionProvider>
          <App />
        </UseCollectionProvider>
      </Router>
    </Auth0Provider>
  </ThemeProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
